// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"d2f24081","248":"ef7a5a79","278":"a0bd8378","601":"6cb2f25a","702":"83d7bd1c"}[chunkId] + ".chunk.js";
};